import { onComposeStateChange } from '../actions/internalActions';
import { openComposeInSxS } from '../actions/publicLazyActions';
import sxsStore from '../store/Store';
import { mutator } from 'satcheljs';

function composeStateMutator(actionMessage: { composeViewState: any }) {
    const { composeViewState } = actionMessage;
    sxsStore.composeId = composeViewState?.composeId;
}

mutator(openComposeInSxS, composeStateMutator);
mutator(onComposeStateChange, composeStateMutator);
